<template>
  <div>
    <p class="block font-light font-sans leading-snug mb-3 subpixel-antialiased text-xl text-black w-full">{{ label }}</p>
    <label :id="generateAriaLabel(name)" class="block font-light font-sans leading-snug mb-1 subpixel-antialiased text-base text-black w-full">{{ button }}</label>
    <div :id="generateAriaDescription(name)" class="hidden">{{ hint }}</div>
    <div class="dropzone" :id="name">
      <button class="dz-message" :aria-describedby="generateAriaDescription(name)">
        <span class="prefix">
          <doe-icon icon="attachment" />
        </span>
        <span>
          {{ button }}
        </span>
      </button>
      <div></div>
    </div>
    <div
      :id="`preview-${name}-${rand}`"
      aria-hidden="true"
      class="hidden"
    ></div>
  </div>
</template>

<script>
import DoeIcon from "@/components/icon/Icon";
import Dropzone from "dropzone";
import modal from "@/mixins/modal";

Dropzone.autoDiscover = false;

export default {
  name: "DoeDropzone",
  mixins: [modal],
  props: {
    name: {
      type: String,
      required: true
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    hint: {
      type: [Array, String]
    },
    button: {
      type: String,
      default: "Add files"
    },
    acceptedTypes: {
      type: String,
    }
  },
  components: {
    DoeIcon
  },
  data() {
    return {
      rand: 0,
      loading: false
    };
  },
  created() {
    this.rand = Math.floor(Math.random() * 90000) + 10000;
  },
  mounted() {
    this.initDropzone();
  },
  methods: {
    generateAriaDescription(fieldName) {
      if (this.hint) {
        return `${fieldName}Description`;
      }
      return false;
    },
    generateAriaLabel(fieldName) {
      if (this.label) {
        return `${fieldName}Label`;
      }
      return false;
    },
    initDropzone() {
      let dropzone = new Dropzone(`#${this.name}`, {
        acceptedFiles: `${this.acceptedTypes}`,
        createImageThumbnails: true,
        maxFiles: 10,
        maxFilesize: 10,
        paramName: "media",
        previewsContainer: `#preview-${this.name}-${this.rand}`,
        // uploadMultiple: false,
        url: `/`,
        sending() {
          this.loading = true;
        },
        success() {
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });

      // dropzone.uploadFiles=function(files){};
      dropzone.on("addedfile", file => {
        // not more than 5mb
        if (file.size > (1024 * 1024 * 5)) {
          dropzone.removeFile(file);
          this.$root.translateModal(
            "The maximum file size is 5MB."
          );
          return false;
        }
        //Checking the permitted file types
        var ext = file.name.substr((file.name.lastIndexOf('.')));
        ext = (ext || "").toLowerCase();  
        if(!this.acceptedTypes.includes(ext)){
          dropzone.removeFile(file);
          this.$root.translateModal(
            "The selected file type is not allowed."
          );
           return false;
        }
        const uuidv4 = require("uuid/v4");
        var reader  = new FileReader();
        reader.readAsDataURL(file);
        let that=this;
        reader.onload = function(e) {
          that.$emit("mediaCreate", {
            uuid: uuidv4(),
            name: file.name,
            size: file.size,
            url: e.target.result,
            type: file.type
          });
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dropzone {
  display: inline-block;
  width: 100%;
  max-width: 400px;
  height: 95px;
  border-radius: 4px;
  border: 2px dashed #041e42;
  background-color: #fafafa;
  position: relative;
  z-index: 1;
}
span {
  @apply align-middle;
}
button.dz-message {
  @apply align-middle block;
  @apply cursor-pointer text-blue-900 font-sans font-semibold;
  @apply py-2 px-2 rounded border-2;
  @apply text-center text-blue-900 bg-gray-400 border-blue-900;
  @apply leading-snug py-2 text-xl;
  @apply mx-auto my-4;
  @apply w-10;
  &:focus {
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
  svg {
    @apply fill-current;
  }
}
span.prefix {
  @apply inline-block mr-1;
}
</style>
